var _path, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotificationActif({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 26,
    viewBox: "0 0 22 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5556 18.3333V11.9778C18.9444 12.1 18.3333 12.2222 17.7222 12.2222H17.1111V19.5556H4.88889V11C4.88889 7.57778 7.57778 4.88889 11 4.88889C11.1222 3.3 11.8556 1.95556 12.8333 0.855556C12.4667 0.366667 11.7333 0 11 0C9.65556 0 8.55556 1.1 8.55556 2.44444V2.81111C4.88889 3.91111 2.44444 7.21111 2.44444 11V18.3333L0 20.7778V22H22V20.7778L19.5556 18.3333ZM8.55556 23.2222C8.55556 24.5667 9.65556 25.6667 11 25.6667C12.3444 25.6667 13.4444 24.5667 13.4444 23.2222H8.55556ZM22 5.5C22 7.82222 20.0444 9.77778 17.7222 9.77778C15.4 9.77778 13.4444 7.82222 13.4444 5.5C13.4444 3.17778 15.4 1.22222 17.7222 1.22222C20.0444 1.22222 22 3.17778 22 5.5Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 5.5,
    r: 4.5,
    fill: "#F89425"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationActif);
export default __webpack_public_path__ + "static/media/notificationActif.be475bb3a6f719a4dfaed0c99bd7463e.svg";
export { ForwardRef as ReactComponent };